import React from 'react';
import { Table } from 'antd';
import { ColumnProps } from 'antd/lib/table/Column';

export type { ColumnProps };

const ProTableColumn: React.FC<ColumnProps<any>> = (props) => {
  const { children, ...resProps } = props;
  return <Table.Column {...resProps} />;
};

export default ProTableColumn;
